module.exports = __webpack_public_path__ + "img/8.880a2b9.jpg";